// Copyright (C) Siemens AG 2026. All rights reserved. Confidential

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as auth0 from 'auth0-js';
import { AppEnvironmentService } from '../app-environment.service';



(window as any).global = window;

@Injectable({ providedIn: 'root' })
export class AuthService {

  // @ts-ignore
  auth0: auth0.WebAuth;
  environmentConfig: any
  usermissngPermission: boolean = false


  constructor(public router: Router, private appEnvironmentService: AppEnvironmentService
  ) {

  }

  initAuth0() {

    this.environmentConfig = this.appEnvironmentService.appEnvData;
    const _redirectUri: string = this.getRedirectURI();
    this.auth0 = new auth0.WebAuth({
      clientID: this.environmentConfig.auth0clientID,
      domain: this.environmentConfig.auth0domain,
      audience: this.environmentConfig.auth0audience,
      responseType: 'token id_token',
      redirectUri: _redirectUri,
      protocol: 'SAML'
    });

  }

  public login(): void {
    if (!this.ensureAuth0Initialized()) {
      return;
    }

    localStorage.clear();
    //this.localStorageService.removeItem('mUserGroup');
    // Go back to the home route
    const cookies = document.cookie.split(";")
    cookies.forEach(cookie => {
      document.cookie = cookie.split("=")[0] + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
    });
    this.auth0.authorize(
      // @ts-ignore
      { connection: 'PcsNeo-SAML', display: "sup" }
    );
  }

  public handleAuthentication(): void {
    if (!this.ensureAuth0Initialized()) {
      this.router.navigate(['/']);
      return;
    }

    this.auth0.parseHash((err: any, authResult: any) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult);
        this.navigateUserBasedOnPermission();

      } else if (err) {

        this.router.navigate(['/']);
        console.log(err)
        alert(`Error: ${err.error}. Check the console for further details.`);
      }


    });

  }

  public navigateUserBasedOnPermission() {

    this.router.navigate(['dashboard']);
  }

  private setSession(authResult: any): void {
    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
  }

  clearStorage() {
    localStorage.clear();
    const cookies = document.cookie.split(";")
    cookies.forEach(cookie => {
      document.cookie = cookie.split("=")[0] + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
    });
  }


  public logout(relog = false): void {
    this.clearStorage();
    if (!this.ensureAuth0Initialized()) {
      return;
    }
    

    this.auth0.logout({returnTo: this.appEnvironmentService.appEnvData.callbackURL});

  }


  private getRedirectURI(): string {
    let res: string = window.location.origin;
    if (res.charAt(-1) !== '/') {
      res += '/'
    }
    res += "callback";
    return res;
  }

  private ensureAuth0Initialized(): boolean {
    if (this.auth0) {
      return true;
    }

    const envConfig = this.appEnvironmentService.appEnvData;
    if (envConfig?.auth0clientID && envConfig?.auth0domain && envConfig?.auth0audience) {
      this.initAuth0();
      return !!this.auth0;
    }

    console.error('[AuthService] Auth0 is not initialized: missing app environment config.');
    return false;
  }

}
